<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import { dateShort } from '../../utils/conv';
  import { DateInput } from 'date-picker-svelte';
  import dayjs from 'dayjs';
  import CustomIcon from '../CustomIcon.svelte';

  export let label;
  export let name;
  export let initialValue = '';
  export let reset = false;
  export let value = new Date();

  const dispatch = createEventDispatcher();

  let dateChosen;

  $: if (reset) {
    resetDate();
  }

  $: onChange(value);

  function resetDate() {
    dateChosen = false;
    value = null;
  }

  onMount(() => {
    let _value = value || initialValue;
    value = _value ? dayjs(_value).toDate() : null;
  });

  function onChange(e) {
    dispatch('onChange', dateShort(e || ''));
  }
</script>

<div class="sm:col-span-2 w-36 relative ">
  {#if typeof value === 'object' || value === null}
    <div
      class="w-full block shadow-sm focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm border-gray-300 rounded-md h-4 relative z-3"
    >
      <DateInput bind:value format="MM/dd/yyyy" placeholder={label} closeOnSelection={true} />
    </div>
    {#if value}
      <a
        class="absolute top-0 right-0 pr-1 -ml-7 h-10 flex items-center"
        href="/"
        on:click|preventDefault={resetDate}
      >
        <CustomIcon name="close" width={18} height={18} color="rgba(51, 51, 51,0.5)" />
      </a>
    {:else}
      <span
        class="border cursor-pointer pointer-events-none border-white border-opacity-0 absolute top-0 right-0 pr-1 -ml-7 h-9 flex items-center z-0"
      >
        <CustomIcon name="date" width="20" height="20" color="rgba(51, 51, 51,0.5)" />
      </span>
    {/if}
  {/if}

  <input {name} type="text" {value} class="invisible w-0 h-0 p-0 m-0 border-0" />
</div>

<style>
  :global(body) {
    --date-picker-foreground: rgb(51, 51, 51);
    --date-picker-highlight-border: #f78907;
    --date-picker-highlight-shadow: transparent;
    --date-picker-selected-color: #fff;
    --date-picker-selected-background: #f78907;
  }
</style>
